import {
    MeshPhongMaterial,
    //TextureLoader,
    VideoTexture
} from "../../../../src/js/three.module.js";
//} from "../../../../src/js/three.module.js";

import { getTextureLoader } from '../../../utils/loaders/loader-manager.js';

const TEXTURE_TYPE_EXTENSIONS = {
    "video": [ "mp4", "webm", "ogg" ]
};

const textureLoader = /* new TextureLoader() */ getTextureLoader();

function createImageTexture( image_url ) {

    return textureLoader.load( image_url );
}

export const DefaultMeshMaterialClass = MeshPhongMaterial;

export function createDefaultMaterial( parameters = {} ) {
    return new DefaultMeshMaterialClass( parameters );
}

export function buildMaterialParameters( parameters = {} ) {
    return {
        alphaTest : 0.1,
        opacity   : 1.0,
        ...parameters
    }
}

function createVideoTextureVideoElement( src, options = {} ) {
    let video = document.createElement( "video" );

    video.src = src;

    video.autoplay = options.autoplay != null ? !!options.autoplay : true;
    video.loop     = options.loop     != null ? !!options.loop     : true; 

    return video;
}

function createVideoTexture( src,  options = {} ) {

    let video = createVideoTextureVideoElement( src, options );

    let texture = new VideoTexture( video );

	if (video.autoplay) {
		texture.update = function() {

			let video = this.image;

			if (video.ended || video.paused) {
				video.play();
			} else {
				VideoTexture.prototype.update.call( this );
			}
		}
	}

	return texture;
}

export function createTextureByImageUrl( image_url ) {

    let ext = image_url.substring( image_url.lastIndexOf(".") + 1 ).toLowerCase();	

    return TEXTURE_TYPE_EXTENSIONS.video.indexOf( ext ) == -1 ? createImageTexture( image_url ) : createVideoTexture( image_url );
}

export function createMaterialByImageUrl( texture_img_url, material_parameters = {} ) {

    const material = createDefaultMaterial( buildMaterialParameters({

        ...material_parameters,
        
        map: createTextureByImageUrl( texture_img_url )

    }));

	material.texture_img_url = texture_img_url;

	return material;
}

export function createMaterialByImageUid( texture_img_uid, material_parameters = {} ) {
    return createMaterialByImageUrl( `/i/${ texture_img_uid }?size=512x512!`, material_parameters );
}

export function getAdditionalObjectsService(){
    return window.additionalObjectsService;
}
